module.exports = __webpack_public_path__ + "0f156e3f10230e28ccc532f537ee77be.png";